<template>
  <div>
    <v-row align="center" no-gutters>
      <v-col cols="auto" class="mr-2">
        Confira e confirme os dados do(s) portador(es)
      </v-col>
      <v-col>
        <v-divider class="bg-primary" />
      </v-col>
    </v-row>

    <v-row class="flex-column">
      <v-col v-for="sector in filteredSectors" :key="sector.id">
        <validation-ticket-card
          ref="forms"
          :sector="sector"
        />
      </v-col>
    </v-row>

    <v-row v-if="cart.totalItems > 1 && !mobile">
      <v-col>
        <t-alert
          color="warning"
          icon="mdi mdi-alert-box-outline"
        >
          Você poderá alterar os dados do portador uma única vez, após a confirmação do pagamento e até 12 horas antes da abertura dos portões do evento.
        </t-alert>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-sheet color="grey-lighten-2" class="pa-4 rounded text-grey-darken-2">
          <v-row class="mx-0">
            <v-col
              cols="2"
              md="1"
              class="d-flex justify-start ps-0 align-start"
              style="max-width: 40px"
            >
              <v-icon color="grey-darken-2" :size="mobile ? 32 : 40">
                mdi-cart-outline
              </v-icon>
            </v-col>
            <v-col cols="10" md="9">
              <h3
                :style="{
                  'font-size': mobile ? '0.8em' : '1.05em',
                  'font-weight': 'normal',
                }"
                class="text-uppercase"
              >
                {{ cart.totalItems }}
                {{ $t("entities.ticket", cart.totalItems) }} no carrinho
              </h3>
              <h4
                :style="{
                  'font-size': mobile ? '1.05em' : '1.3em',
                  'font-weight': 'normal',
                }"
              >
                R$ {{ cart.totalPrice.toFixed(2).replace(".", ",") }}
              </h4>
              <small
                :style="{
                  'font-size': mobile ? '0.7em' : '0.85em',
                  'font-weight': 'normal',
                }"
              >
                TAXA DE SERVIÇO: R$
                {{ cart.totalFees.toFixed(2).replace(".", ",") }}</small>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, useTemplateRef } from "vue";
import { useDisplay } from "vuetify";

import TAlert from "@/components/core/TAlert.vue";
import ValidationTicketCard from "@/components/Ticket/ValidationTicketCard.vue";
import { useCheckoutStore } from "@/stores/checkout";
import { useCartStore } from "@/stores/cart";

const checkout = useCheckoutStore();
const cart = useCartStore();

const forms = useTemplateRef<
  InstanceType<typeof ValidationTicketCard>[] | null
>("forms");

defineOptions({
  name: "ValidationTicketForm",
});

const { mobile } = useDisplay();

/**
 * Filters the sectors in the cart to only those that have tickets associated with them.
 */
const filteredSectors = computed(() =>
  cart.sectors.filter(s => cart.tickets.map(t => t.sector.id).includes(s.id)),
);

// Methods

const validate = async (): Promise<boolean> => {
  if (forms.value === null || forms.value.length === 0) return false;

  // I couldn't figure out a way to type this properly
  const validations = forms.value.map(form => form.validate());

  const results = await Promise.all(validations);

  return results.every(v => v);
};

const cancel = (): boolean => {
  checkout.timer.stop();
  return true;
};

// Expose methods to parent component
defineExpose({
  validate,
  cancel,
});

// Lifecycle hooks
onMounted(() => {
  validate();
});
</script>
